module.exports = __webpack_public_path__ + "img/page16-top.5faf8bb6.png";